import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export enum FunnelType {
    RESERVE = "reserve",
    RENT = "rent",
    QUOTE = "quote",
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
